<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <Wxts :wxtsList="wxtsList" />
    </div>

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Wxts from '../../../components/Wxts.vue';
export default {
  name: "NonContractOrder",
  components: { Wxts },
  data() {
    return {
      breadcrumb: [
        { name: "运单管理" },
        { name: "运单列表" },
      ],
      wxtsList: [
        {
          name:'请先确认是否已经完成对客户、车辆、人员的创建，创建完成后方可派单。'
        },
      ],
      menu: [
        {
          name: "自有车辆",
          path: '/order/nocontract/own',
        },
        {
          name: "雇佣车辆",
          path: '/order/nocontract/hire',
        },
      ],
      menuIndex: '/order/nocontract/own',
    };
  },
  methods: {},
  mounted() {
    this.menu.map(v => {
      if (this.$route.path.includes(v.path)) {
        this.menuIndex = v.path
      }
    })
  },
};
</script>

<style scoped>
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>